/**
 * Base function to copy text to clipboard without notifications.
 * For React components, use the useCopyToClipboard hook instead.
 * @param {string} textToCopy - The text to be copied
 * @param {string|null} contentId - Optional ID of the container element
 * @returns {Promise<void>}
 */
export const copyTextToClipboard = async (textToCopy, contentId = null) => {
  // navigator clipboard api needs a secure context (https)
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(textToCopy);
  }
  // local development or older browsers
  const textArea = document.createElement('textarea');
  textArea.value = textToCopy;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';

  const content = contentId != null ? document.getElementById(contentId) : document.body;
  content.appendChild(textArea);

  textArea.focus();
  textArea.select();
  document.execCommand('copy');
  content && content.removeChild && content.removeChild(textArea);
};
